module.exports = __webpack_public_path__ + "media/images/ico-menu-collapsed-f5faac34.svg";